// extracted by mini-css-extract-plugin
export var cartContainer = "_mf-4";
export var gray = "_mf-1";
export var itemContainer = "_mf-2";
export var itemDetails = "_mf-3";
export var strong = "_mf-0";